import { Outlet } from "react-router-dom";
import { useEffect, useState } from "react";
import * as Sentry from "@sentry/react";
import 'react-tooltip/dist/react-tooltip.css'
import Snackbar from "./components/Snackbar";

function ErrorFallback() {
  return (
    <div style={{ padding: 24, textAlign: "center" }}>
      <h2>일시적인 오류가 발생했습니다</h2>
      <p>잠시 후 다시 시도해 주세요.</p>
      <button
        onClick={async () => {
          try { await Sentry.flush(2000); } catch {}
          window.location.reload();
        }}
        style={{ padding: "8px 16px", marginTop: 12 }}
      >
        새로고침
      </button>
    </div>
  );
}

function App() {
  const [networkErrorTxt, setNetworkErrorTxt] = useState('');

  useEffect(() => {
    const handler = () => setNetworkErrorTxt('네트워크 연결을 확인 후 다시 시도해주세요.');
    window.addEventListener('app:network-error', handler);
    return () => window.removeEventListener('app:network-error', handler);
  }, []);

  useEffect(() => {
    if (!networkErrorTxt) return;
    const timer = setTimeout(() => setNetworkErrorTxt(''), 2000);
    return () => clearTimeout(timer);
  }, [networkErrorTxt]);

  return (
    <Sentry.ErrorBoundary
      fallback={<ErrorFallback />}
      beforeCapture={(scope) => {
        scope.setTag("error.category", "화면 깨짐 / 빈 화면");
      }}
    >
      <Outlet />
      {networkErrorTxt !== '' && (
        <div className="fixed inset-0 z-[2000] pointer-events-none">
          <Snackbar>{networkErrorTxt}</Snackbar>
        </div>
      )}
    </Sentry.ErrorBoundary>
  );
}

export default App;
